import { Alpine } from "../../../vendor/livewire/livewire/dist/livewire.esm";

Alpine.data('poll', (pollId) => ({
  supabaseUrl: null,
  supabaseAnonKey: null,
  answered: false,
  loading: false,
  pollId,
  results: null,

  init() {
    this.supabaseUrl = document.querySelector('meta[name="supabase-url"]')?.getAttribute('content');
    this.supabaseAnonKey = document.querySelector('meta[name="supabase-anon-key"]')?.getAttribute('content');
    if (!this.supabaseUrl || !this.supabaseAnonKey) {
      console.error('Supabase URL or Anon Key not found in meta tags.');
      return;
    }

    // Hvis der er stemt før → lås og hent resultater
    const stored = localStorage.getItem(this.key());
    if (stored) {
      this.answered = true;
      this.fetchResults();
    }
  },

  key() { return `poll_voted_${this.pollId}`; },

  saveVote(optionId, answerText) {
    localStorage.setItem(this.key(), JSON.stringify({ optionId, answerText, at: Date.now() }));
  },

  submitAnswer(optionId, answerText) {
    if (this.answered || this.loading) return;
    this.loading = true;

    // Lås UI og gem i localStorage
    this.answered = true;
    this.saveVote(optionId, answerText);

    fetch(`${this.supabaseUrl}/rest/v1/poll_answers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': this.supabaseAnonKey,
      },
      body: JSON.stringify({
        poll_id: this.pollId,
        option_id: optionId,
        option_text: answerText,
      }),
    })
    .then(res => {
      if (!res.ok) throw new Error('Vote rejected');
      // hent resultater når stemmen er registreret
      this.fetchResults();
    })
    .catch(error => {
      console.error('Error submitting poll answer:', error);
      localStorage.removeItem(this.key());
      this.answered = false;
      alert('Kunne ikke registrere din stemme. Prøv igen.');
    })
    .finally(() => { this.loading = false; });
  },

  fetchResults() {
    fetch(`${this.supabaseUrl}/rest/v1/poll_answer_distribution?poll_id=eq.${this.pollId}`, {
      headers: { 'apikey': this.supabaseAnonKey },
    })
    .then(r => r.json())
    .then(data => {
      this.results = data;
    })
    .catch(error => console.error('Error fetching poll results:', error));
  },

  getPercentage(optionId) {
    if (!this.results) return 0;
    const option = this.results.find(item => item.option_id === optionId);
    return option?.percentage || 0;
  },

  getVotes(optionId) {
    if (!this.results) return 0;
    const option = this.results.find(item => item.option_id === optionId);
    return option?.answer_count || 0;
  }
}));